import { render, staticRenderFns } from "./monitorCBBList.vue?vue&type=template&id=4781a7dc&scoped=true&"
import script from "./monitorCBBList.vue?vue&type=script&lang=js&"
export * from "./monitorCBBList.vue?vue&type=script&lang=js&"
import style0 from "./monitorCBBList.vue?vue&type=style&index=0&id=4781a7dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4781a7dc",
  null
  
)

export default component.exports